<template>
	<div class="main_user  p-3">
		<div class="categ_info p-3 pt-0" v-if="obj_to_null(this.user)">
			<div class="row">
				<div class="col-lg-6 col-xs-12 pl-5 pr-5">
					<div class="info">
                        <div class="mb-8 flex items-center">
                            <span class="text-warning">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="vue-feather text-theme dark-text-theme mr-3 feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                            </span>
                             <b class="text-md font-bold fs-xl">
                                 {{__t('USER_DESCRIPTION_FIELDS')}}
                             </b>
                        </div>
					</div>

					<div class="usr_field mt-5" v-if="left_side_fileds.length > 0" v-for="inp in left_side_fileds">
						<div class="form-group" v-if="inp.sub_type != 'textarea'">
							<label class="form-label" :for="inp.type + '_usr'">
								{{ __t(inp.name) }}
							</label>

							<div class="input-group flex-nowrap input-group-l">
								<div class="input-group-prepend">
									<span class="input-group-text">
										<i class="fal fs-xl" :class="inp.icon"></i>
									</span>
								</div>

								<b-form-input
									v-if="inp.sub_type == 'input'"
									:readonly="inp.readonly"
									class="input-text form-control"
									:key="inp.type"
									:state=validate_field(inp)
									v-model="inp.value"
									:sub_type="inp.sub_type"
									:id="inp.type + '_usr'"
								>
								</b-form-input>


								<the-mask
									v-if="inp.sub_type == 'phone'"
									:mask="['+## (###) ###-##-##','+## (###) ###-##-##']"
									ref="phone_inp"
									class="input-text form-input form-control"
									v-bind:class="{ 'is-invalid': !validate_field(inp),'fill': validate_field(inp) }"
									id="my-phone"
									type="text"
									v-model="inp.value"
									:masked="false"/>

							</div>

							<b-form-text id="input-live-help">
								{{inp.descr}}
							</b-form-text>
						</div>

                        <!--
                        <div class="user_descr" v-if="inp.sub_type == 'textarea'">
                            <label class="form-label" :for="inp.type + '_usr'">
                                {{ __t(inp.name) }}
                            </label>
                            <vue-editor v-if="inp.sub_type == 'textarea'" :editor-toolbar="editor_rules" id="problem" v-model="inp.value"></vue-editor>
                        </div>
                        -->

					</div>
				</div>


				<div class="col-lg-6 col-xs-12 border-left  pl-5 pr-5">
					<div class="info">
						<div class="panel-tag">
							{{__t('USER_DESCRIPTION_PASS_FIELDS')}}
						</div>
					</div>

					<div class="usr_field mt-5" v-if="left_side_fileds.length > 0" v-for="inp in right_side_fileds">
					<div class="form-group">
						<label class="form-label" :for="inp.type + '_usr'">
							{{ __t(inp.name) }}
						</label>

						<div class="input-group flex-nowrap input-group-l">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<i class="fal fs-xl" :class="inp.icon"></i>
								</span>
							</div>
							<b-form-input
								:readonly="inp.readonly"
								class="input-text form-control"
								:key="inp.type"
								type="password"
								:state=validate_field(inp)
								v-model="inp.value"
								:sub_type="inp.sub_type"
								:id="inp.type + '_usr'"
							>
							</b-form-input>

						</div>

						<b-form-text id="input-live-help">
							{{inp.descr}}
						</b-form-text>
					</div>
					</div>
				</div>

			</div>
			<div class="next_step text-right">
				<button class="btn   btn-lg  mt-3 mb-3 imc_succ " :class="{
                                                      'btn-success' : can_save,
                                                      'btn-outline-warning' : !can_save
                                                }" v-on:click.prevent="save">
					<span class="fal fal fa-check mr-1" v-if="can_save"></span>
					<span class="fal fa-exclamation-triangle mr-1" v-if="!can_save"></span>
					{{__t('SAVE')}}
				</button>

			</div>
		</div>

	</div>
</template>

<script>
    import { VueEditor } from "vue2-editor";
export default {
	name: "user_info",
	props: {
		user: {
			type: Object
		}
	},
    components: {
        VueEditor,
    },
	data() {
		return {
			is_load: false,
			inp_fields : [],
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
		}
	},

	mounted() {
		if(this.user.hasOwnProperty("fields")){
			return this.user.fields.map(itm => {
				this.inp_fields.push(itm);
			})
		}
	},

	methods : {

		validate_field(inp) {
			if(inp.sub_type === 'password') {
				if(this.password_field != null) {
					return this.password_field.value == null || this.password_field.value == "" ||  this.passwork_confirm_ok;
				}
			}
			else {
				if (inp.required) {
					return inp.value != null && inp.value.length >= 2
				}
			}

			return true;
		},

		async save() {
			if(this.can_save) {
				_core.showloading();
				await api.put('/internal/user/save',{
					'data' : this.inp_fields,
					'type' : "user"
				}).then(({data}) => {
					_core.hideloading();

					if (data.status === "operation_success") {
						EventBus.$emit("reload_full_user");
					}
				}).catch(({response}) => {
					_core.hideloading();
					EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
				});
			}
		},
	},

	computed : {

		can_save() {
			let can_save = true;
			this.inp_fields.map(itm => {
				if(itm.required){
				    if(itm.sub_type != 'textarea') {
                        if (itm.value == null || itm.value.length < 2) {
                            can_save = false;
                        }
                    }
				}
			});

			return can_save;
		},

		right_side_fileds() {
			return this.inp_fields.filter(itm => {
				return (itm.sub_type == "password" || itm.type == "password1")
			});
		},

		left_side_fileds() {
			return this.inp_fields.filter(itm => {
				return !(itm.sub_type == "password" || itm.type == "password1" || itm.type.startsWith("order"))
			});
		},

		password_confirm_field() {
			let itm = null;
			this.inp_fields.map(item => {
				if(item.type == 'password1') {
					itm = item;
				}
			});
			return itm;
		},

		password_field() {
			let itm = null;
			this.inp_fields.map(item => {
				if(item.type == 'password') {
					itm = item;
				}
			});
			return itm;
		},

		show_confirm() {
			return this.password_field != null && this.password_field.value != null && this.password_field.value.length > 2;
		},

		password_ok(){

			return this.password_field != null
				&& this.password_field.value != null
				&& this.password_field.value.length > 5;

		},

		passwork_confirm_ok() {
			let confirm_ok = this.password_confirm_field != null && this.password_confirm_field.value != null && this.password_confirm_field.value.length > 5;
			return confirm_ok && this.password_ok && this.password_field.value == this.password_confirm_field.value;
		},

		fields () {
			if(this.user.hasOwnProperty("fields")) {
				return this.user.fields;
			}

			return [];
		}
	},
}
</script>

<style scoped>

</style>
